import { getSurveyResult, submitSurveyResult } from 'services/fake-door'
import { SurveyParams, SurveyResultApiResponse, SurveyType } from 'services/fake-door/types'

import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from '@tanstack/react-query'

type UseGetSurveyResultOptions = Omit<
  UseQueryOptions<SurveyResultApiResponse | null, Error>,
  'queryKey' | 'queryFn'
>

export const useGetSurveyResult = (
  surveyType: SurveyType,
  accountNumber: string,
  options?: UseGetSurveyResultOptions,
) =>
  useQuery<SurveyResultApiResponse | null, Error>(
    ['fake-door-survey', surveyType, accountNumber],
    () => getSurveyResult(surveyType, accountNumber),
    {
      ...options,
    },
  )

export const useSubmitSurveyResult = (
  options?: UseMutationOptions<SurveyResultApiResponse, Error, SurveyParams>,
) =>
  useMutation<SurveyResultApiResponse, Error, SurveyParams>(submitSurveyResult, {
    mutationKey: ['submit-fake-door-survey'],
    ...options,
  })
